<template>
  <div></div>
</template>

<script>
export default {
  name: "notice",
};
</script>

<style scoped></style>
